/**
 * Canonical catalog string IDs for passive DOM identity (`data-hen-id`) and
 * Storybook `parameters.edu.id`. Aligned with Eventing Strategy SAD §7
 * (Suggested Event Taxonomy) plus `hen.navbar` from EDUN-11216.
 */
export const COMPONENT_IDS = {
  Accordion: 'hen.accordion',
  AccordionItem: 'hen.accordionItem',
  ArticleCard: 'hen.articleCard',
  ArticleHeroBanner: 'hen.articleHeroBanner',
  Badge: 'hen.badge',
  BrandCard: 'hen.brandCard',
  Brow: 'hen.brow',
  Button: 'hen.button',
  Callout: 'hen.callout',
  Card: 'hen.card',
  CareerExplorer: 'hen.careerExplorer',
  CareerExplorerPeek: 'hen.careerExplorerPeek',
  CareerExplorerRecommendations: 'hen.careerExplorerRecommendations',
  CareerExplorerSelector: 'hen.careerExplorerSelector',
  CategoryHubSection: 'hen.categoryHubSection',
  ChatMessage: 'hen.chatMessage',
  Checkbox: 'hen.checkbox',
  CheckboxButton: 'hen.checkboxButton',
  Combobox: 'hen.combobox',
  ComparisonBar: 'hen.comparisonBar',
  ComparisonTable: 'hen.comparisonTable',
  DegreeCardDetailed: 'hen.degreeCardDetailed',
  DegreeCardSimple: 'hen.degreeCardSimple',
  DegreeCardTiny: 'hen.degreeCardTiny',
  Drawer: 'hen.drawer',
  EmailBanner: 'hen.emailBanner',
  ExpertBio: 'hen.expertBio',
  ExportDialog: 'hen.exportDialog',
  FeedbackBox: 'hen.feedbackBox',
  FileDropzone: 'hen.fileDropzone',
  Form: 'hen.form',
  Heading: 'hen.heading',
  Hero: 'hen.hero',
  ImageCard: 'hen.imageCard',
  InfoCard: 'hen.infoCard',
  Input: 'hen.input',
  KPIBanner: 'hen.kpiBanner',
  Link: 'hen.link',
  LineClamp: 'hen.lineClamp',
  LinearGauge: 'hen.linearGauge',
  LoadingDots: 'hen.loadingDots',
  MediaGallery: 'hen.mediaGallery',
  MediaGalleryLibrary: 'hen.mediaGalleryLibrary',
  MediaGalleryViewer: 'hen.mediaGalleryViewer',
  Modal: 'hen.modal',
  MultiSelect: 'hen.multiSelect',
  Navbar: 'hen.navbar',
  NavbarMenuContent: 'hen.navbarMenuContent',
  NavTabs: 'hen.navTabs',
  Pagination: 'hen.pagination',
  PillButton: 'hen.pillButton',
  Popover: 'hen.popover',
  Price: 'hen.price',
  Progress: 'hen.progress',
  ProgressGroup: 'hen.progressGroup',
  Radio: 'hen.radio',
  Rating: 'hen.rating',
  ScrollArea: 'hen.scrollArea',
  Select: 'hen.select',
  SelectionTile: 'hen.selectionTile',
  Separator: 'hen.separator',
  ShowMore: 'hen.showMore',
  StatColumn: 'hen.statColumn',
  StatColumns: 'hen.statColumns',
  StickyBar: 'hen.stickyBar',
  StudentLoansBanner: 'hen.studentLoansBanner',
  StudentLoansInline: 'hen.studentLoansInline',
  Switch: 'hen.switch',
  TabItem: 'hen.tabItem',
  Tabs: 'hen.tabs',
  TagLink: 'hen.tagLink',
  Text: 'hen.text',
  Textarea: 'hen.textarea',
  TocNav: 'hen.tocNav',
  Tooltip: 'hen.tooltip',
  ValueProp: 'hen.valueProp',
} as const;

export type ComponentId = (typeof COMPONENT_IDS)[keyof typeof COMPONENT_IDS];
